import commonApi from '@api/common'
import Api from '@api/xiu_yan/siYiGroupApi'
import { HOME_PATH } from '@constant'
import { getObjValue, isPhone } from '@hlj/hlj-utils'
import { isSiDaProperty } from '@merchant-backend/util'
import { getSubmitModalContent } from '@util'
import { message, Modal } from 'hljd'
import { action, observable, runInAction } from 'mobx'
import { hashHistory } from 'react-router'

class Store {
  @observable country = []
  getCountry = async () => {
    const { data } = await commonApi.getAllAreaApi()
    this.country = data || []
  }

  //地图相关
  map
  marker

  //id
  id
  //审核状态
  @observable status = 2
  @observable reason = ''
  //表单字段
  @observable name = ''
  @observable property_id = ''
  @observable property_name = ''
  @observable contact_mobile = ''
  @observable shop_phone = ''

  @observable shop_area = []
  @observable shop_area_chinese = []
  @observable address = ''
  @observable latitude = ''
  @observable longitude = ''
  @observable logo_path_square = ''
  @observable des = ''
  @observable cover_path = ''

  @action
  changeField = type => value => {
    if (type === 'shop_phone' || type === 'contact_mobile') {
      this[type] = value.replace(/[^0-9]+/, '')
    } else {
      this[type] = value
    }
  }

  //上传图片
  @action
  upload = type => (file, src) => {
    this[type] = src
  }

  //删除图片
  @action
  removeImg = type => () => {
    this[type] = ''
  }

  @action
  clipPic = type => ({ clipUrl }) => {
    this[type] = clipUrl
  }

  @action
  clipImgGallery = type => ({ clipUrl, index }) => {
    this[type] = this[type].map((item, i) => {
      if (i === index) {
        item.img = clipUrl
      }
      return item
    })
  }

  @observable examine
  @observable areas = ''

  fromCreat
  //获取信息
  @action
  getStoreInfo = async fromCreat => {
    this.fromCreat = fromCreat

    if (fromCreat) {
      let {
        data: { merchant },
        success
      } = await Api.getGroupInfo()
      if (success) {
        this.readData(merchant || {})
      }
    } else {
      let { data, success } = await Api.merchantInfo({ is_pending: true })
      runInAction('list', () => {
        if (success) {
          this.readData(data || {})
        }
      })
    }
  }

  @action
  readData = (data = {}) => {
    this.property_id = data.property_id
    this.id = data.id

    this.latitude = data.latitude || ''
    this.longitude = data.longitude || ''
    this.name = data.name || ''
    this.status = data.status || ''
    this.contact_mobile = data.contact_mobile || ''
    this.shop_area =
      [
        '' + getObjValue(data, 'shop_area.parent.parent.id'),
        '' + getObjValue(data, 'shop_area.parent.id'),
        '' + getObjValue(data, 'shop_area.id')
      ] || ''
    this.areas = getObjValue(data, 'shop_area.id')
    this.shop_area_chinese =
      [
        getObjValue(data, 'shop_area.parent.parent.area_name'),
        getObjValue(data, 'shop_area.parent.area_name'),
        ''
      ] || ''
    this.logo_path_square = data.logo_path_square || ''
    this.address = data.address || ''
    this.reason = data.reason || ''
    this.shop_phone = data.shop_phone || ''

    this.des = data.des || ''
    this.cover_path = data.cover_path || ''
  }

  //编辑
  @observable loading = false
  @action
  updateStoreInfo = indexStore => async () => {
    const { fromCreat } = this

    let params = this.getFormData()

    this.loading = true

    if (params) {
      if (fromCreat) {
        indexStore.currentStep = 1
        indexStore.getMerchantData(params)
      } else {
        const { success } = await Api.postEdit(params)
        if (success) {
          this.loading = false
          document.body.scrollTop = 0

          Modal.success({
            ...getSubmitModalContent('mainAdmin'),
            onOk() {
              hashHistory.push(HOME_PATH)
            }
          })
        } else {
          this.loading = false
        }
      }
    } else {
      this.loading = false
    }
  }

  //表单校验
  validation = () => {
    const {
      name,
      logo_path_square,
      contact_mobile,
      shop_phone,
      shop_area,
      address,
      latitude,
      longitude,
      des,
      cover_path
    } = this

    if (logo_path_square === '') {
      return '请上传团队logo'
    }
    if (name.trim() === '') {
      return '请输入店铺名称'
    }
    if (shop_area.length == 0) {
      return '请选择所在地区'
    }
    if (address.trim() === '') {
      return '请输入详细地址'
    }
    if (!(latitude && longitude)) {
      return '请在地图上进行标记'
    }
    if (contact_mobile.trim() === '') {
      return '请输入联系手机'
    }
    if (!isPhone(contact_mobile)) {
      return '请输入正确的手机号码'
    }
    if (shop_phone.trim() === '') {
      return '请输入门店电话'
    }
    if (isSiDaProperty()) {
      if (des.trim() === '') {
        return '请输入团队简介'
      }
      if (cover_path == '') {
        return '请上传团队封面'
      }
    }

    return 'pass'
  }

  //获取表单提交参数
  getFormData = () => {
    const {
      name,
      contact_mobile,
      shop_phone,
      shop_area,
      areas,
      address,
      latitude,
      longitude,
      logo_path_square,
      id,
      examine,
      fromCreat,
      des,
      cover_path
    } = this

    let msg = this.validation()

    if (msg == 'pass') {
      return {
        id,
        name,
        contact_mobile,
        shop_phone,
        shop_area_id: examine == 1 ? areas : shop_area[2],
        address,
        latitude,
        longitude,
        logo_path_square,
        shop_type: 0,
        shop_area,
        property: 11,
        is_register_improve: fromCreat ? 1 : 0,
        des,
        cover_path
      }
    } else {
      message.warning(msg, 2)
      return false
    }
  }
}

export default Store
